import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Header, SubHeader, WidthWrapper } from '../../components/Layout/styles';

const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.backgroundOrange};
  padding: 80px 20px;

  @media (min-width: 768px) {
    padding: 80px 5px;
  }
`;
const DescriptionWrapper = styled.div`
  display: flex;
  flex-flow: column;
  margin-bottom: 60px;
  margin-left: auto;
  margin-right: auto;
  max-width: 700px;
  text-align: center;
`;

const StyledSubHeader = styled(SubHeader)`
  text-align: center;
  max-width: 700px;
  margin: 0 auto;

  ol {
    list-style: none;
    padding: 0;
  }

  li {
    text-align: center;
    padding: 0;
  }
`;

export const HowItWorks: React.FC = () => {
  const { t } = useTranslation('wanted-listings');

  const steps = [
    t('HOW_IT_WORKS.STEPS.1'),
    t('HOW_IT_WORKS.STEPS.2'),
    t('HOW_IT_WORKS.STEPS.3'),
    t('HOW_IT_WORKS.STEPS.4'),
    t('HOW_IT_WORKS.STEPS.5'),
  ];

  return (
    <Wrapper>
      <WidthWrapper>
        <DescriptionWrapper>
          <Header>{t('HOW_IT_WORKS.TITLE')}</Header>
          <StyledSubHeader>
            <ol>
              {steps.map((step, index) => (
                <li key={index} className="my-3">
                  {step}
                </li>
              ))}
            </ol>
            <div style={{ marginTop: '2rem', fontSize: '1.1rem', fontWeight: 600 }}>
              Dzięki Najmuje.com to Ty jako najemca rządzisz!
            </div>
            <div style={{ marginTop: '0.5rem', fontSize: '1rem' }}>Najmuje.com - Jedyne takie miejsce na rynku!</div>
          </StyledSubHeader>
        </DescriptionWrapper>
      </WidthWrapper>
    </Wrapper>
  );
};
